module.exports = __webpack_public_path__ + "static/media/microsoftIcon.f32b3f89.svg";